import { Component, Input } from '@angular/core';
import { PipesModule } from '../../../../shared/pipes/pipes.module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-job-info',
  templateUrl: './job-info.component.html',
  styleUrl: './job-info.component.scss',
  standalone: true,
  imports: [PipesModule, CommonModule],
})
export class JobInfoComponent {
  @Input() isPWCEnabled: boolean = false;
  @Input() isPwcPresumptive: boolean = false;
  @Input() job: any;
  @Input() jobLocation: any;
  @Input() getFixedValueDigits!: (value: any) => string;
  @Input() getFormattedNumber!: (value: any) => string;
}
